import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { HttpError } from './lib/api.ts';

// If any query returns 401, the session must have expired — force the auth
// gate to re-check and redirect. Without this, every 5s poll would surface a
// red error and React Router would never navigate back to /login.
const qc = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: 5000,
      refetchOnWindowFocus: false,
      staleTime: 4000,
      retry: (failureCount, err) => {
        if (err instanceof HttpError && err.status === 401) return false;
        return failureCount < 1;
      },
    },
  },
  queryCache: new QueryCache({
    onError: (err) => {
      if (err instanceof HttpError && err.status === 401) {
        // Mark `me` stale; App will re-fetch and bounce to /login.
        qc.setQueryData(['me'], { authenticated: false });
      }
    },
  }),
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root missing');
createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={qc}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
